import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import PartnersHub from "./pages/PartnersHub";
import PricingPage from "./pages/PricingPage";
import RestaurantsPage from "./pages/RestaurantsPage";
import HealthPage from "./pages/HealthPage";
import ToursPage from "./pages/ToursPage";
import ExperiencesPage from "./pages/ExperiencesPage";
import ScrollToTop from "./components/aa/ScrollToTop";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./i18n/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<PartnersHub />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/partners/resorts" element={<LandingPage />} />
            <Route path="/partners/restaurants" element={<RestaurantsPage />} />
            <Route path="/partners/health" element={<HealthPage />} />
            <Route path="/partners/tours" element={<ToursPage />} />
            <Route path="/partners/experiences" element={<ExperiencesPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </LanguageProvider>
    </div>
  );
}

export default App;
